module.exports = __webpack_public_path__ + "static/img/17.67dc828.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/17.png
// module id = yfRd
// module chunks = 0